// Axios instance for public/unauthenticated API calls.
// This instance does not include auth headers, X-ORIGINAL-URL, or interceptors.
// Use for flows like unsubscribe or public endpoints where sensitive data (e.g., JWT tokens) must not leak in headers.
import axios from 'axios';

const publicAxios = axios.create({});

export default publicAxios;